"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var API = 'CALL_API';
var _default = API;
exports["default"] = _default;